// store configuration
import configureStore from './ConfigureStore';

export const store = configureStore();
